import React from "react";
import NewsletterSubscriptionEmailSubmit from "./newsletter-subscription-email-submit";
import NewsletterSubscriptionInterests from "./newsletter-subscription-interests";
import NewsletterSubscriptionConfirm from "./newsletter-subscription-confirm";
import ServerErrors from "./server-errors/server-errors";

class NewsletterSubscription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newsLetterData: this.props.data,
      firstName: this.props.data.firstName,
      email: this.props.data.email,
      newsletter: this.props.data.newsletter,
      activeIndex: 1,
      errors: [],
    };
  }

  setInterests = (singleInterest) => {
    singleInterest.value
      ? (singleInterest.value = false)
      : (singleInterest.value = true);
  };

  handleInterestsSubmit = () => {
    this.handleDataReq(false);
  };

  handleEmailSubmit = (email, firstName) => {
    this.setState(
      {
        email: email,
        firstName: firstName,
      },
      this.handleDataReq
    );
  };

  removeServerErrors = () => {
    this.setState({ errors: [] });
  };

  handleDataReq = (isNewsletterSubscribe = true) => {
    let interests = null;
    let email = null;
    let firstName = null;
    let newsletter = null;
    let consentCodeName = null;

    if (this.state.newsLetterData != null) {
      newsletter = this.state.newsletter;
      email = this.state.email;
      firstName = this.state.firstName;
      consentCodeName = this.state.newsLetterData.consentCodeName;
      interests = this.state.newsLetterData.interests;
    }

    let endpoint, request;
    if (isNewsletterSubscribe) {
      endpoint = this.props.newsletterSubscribeEndPointUrl;
      request = {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          RequestVerificationToken:
            this.state.newsLetterData.requestVerificationToken,
        },
        body: JSON.stringify({
          email: email,
          firstName: firstName,
          newsletter: newsletter,
          consentCodeName: consentCodeName,
        }),
      };
    } else {
      endpoint = this.props.interestEndPointUrl;
      request = {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          RequestVerificationToken:
            this.state.newsLetterData.requestVerificationToken,
        },
        body: JSON.stringify({
          email: email,
          interests: interests,
        }),
      };
    }

    fetch(endpoint, request)
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          return response.json();
        } else {
          console.log("Something went wrong");
        }
      })
      .then((json) => {
        if (!json.success) {
          this.setState({
            errors: json.errorMessages,
          });

          return;
        } else {
          this.removeServerErrors();
        }

        this.setState({
          activeIndex: this.state.activeIndex + 1,
        });
      })
      .catch((err) => err);
  };

  renderSteps = (activeIndex) => {
    if (activeIndex === 1) {
      return (
        <NewsletterSubscriptionEmailSubmit
          resourcedTexts={this.props.resourcedTexts}
          newsLetterData={this.state.newsLetterData}
          onSubmit={this.handleEmailSubmit}
        />
      );
    } else if (activeIndex === 2) {
      return (
        <NewsletterSubscriptionInterests
          resourcedTexts={this.props.resourcedTexts}
          interests={this.state.newsLetterData.interests}
          setInterests={this.setInterests}
          handleInterestsSubmit={this.handleInterestsSubmit}
          eventCodeInterests={this.state.newsLetterData.eventCodes.interests}
        />
      );
    } else if (activeIndex === 3) {
      return (
        <NewsletterSubscriptionConfirm
          resourcedTexts={this.props.resourcedTexts}
        />
      );
    }
  };

  render() {
    return (
      <section className="newsletter-subscription">
        {this.state.errors !== undefined && this.state.errors.length ? (
          <ServerErrors
            resourcedTexts={this.props.resourcedTexts}
            serverErrors={this.state.errors}
            onRemoveErrors={this.removeServerErrors}
          />
        ) : null}
        <div className="newsletter-subscription__content">
          {this.renderSteps(this.state.activeIndex)}
        </div>
      </section>
    );
  }
}

export default NewsletterSubscription;
